import { render } from "./shortcutMenu.vue?vue&type=template&id=274da7ce&scoped=true"
import script from "./shortcutMenu.vue?vue&type=script&lang=js"
export * from "./shortcutMenu.vue?vue&type=script&lang=js"

import "./shortcutMenu.vue?vue&type=style&index=0&id=274da7ce&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/FK-YF23001-01-生产-01-综合管理后台sznc_admin-前端构建部署/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274da7ce"]])

export default __exports__